export const layerNames: {
  [key: string]: string
} = {
  'product-layer': 'Generisches Produkt',
  'timber-frame-layer': 'Holzrahmenschicht (Legacy)',
  'timber-frame-layer-wall': 'Holzrahmenschicht',
  'timber-frame-layer-roof-ceiling': 'Holzbalkenschicht',
  'plate-layer': 'Statisch wirksame Platte',
  'clt-assembly-layer': 'CLT Schicht',
}

export const assemblyTypes: {
  label: string
  usage_type: AssemblyTypes
}[] = [
  {
    label: 'Innenwände',
    usage_type: 'Inner',
  },
  {
    label: 'Aussenwände',
    usage_type: 'Outer',
  },
  {
    label: 'Decken',
    usage_type: 'Ceiling',
  },
  {
    label: 'Dächer',
    usage_type: 'Roof',
  },
]

export const assemblyKinds: {
  label: string
  type: AssemblyKind
  enabledOn: AssemblyTypes[]
}[] = [
  {
    label: 'Holzrahmen',
    type: 'timber-frame-assembly-wall',
    enabledOn: ['Inner', 'Outer'],
  },
  {
    label: 'Holzbalken',
    type: 'timber-frame-assembly-roof',
    enabledOn: ['Roof'],
  },
  {
    label: 'Holzbalken',
    type: 'timber-frame-assembly-ceiling',
    enabledOn: ['Ceiling'],
  },
  {
    label: 'CLT',
    type: 'clt-assembly-roof',
    enabledOn: ['Roof'],
  },
  {
    label: 'CLT',
    type: 'clt-assembly-ceiling',
    enabledOn: ['Ceiling'],
  },
  {
    label: 'Holzrahmen (Legacy)',
    type: 'timber-frame-assembly',
    enabledOn: [],
  },
  {
    label: 'CLT (Legacy)',
    type: 'clt-assembly',
    enabledOn: [],
  },
]
